<template>
  <v-container>
    <v-row
      ><v-col justify="center" md="12" lg="12">
        <v-card color="rgb(255, 0, 0, 0)">
          <v-card-title class="text-h5" style="word-break: keep-all"
            ><v-avatar dark class="white--text">
              <v-icon color="#2B2118">mdi-database</v-icon>
            </v-avatar>
            Database Query Interface - Fossil Pollen
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      ><v-col justify="center" md="12" lg="12">
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
</style>